import { Dropdown } from 'primereact/dropdown';
import { useProdServiceBuild } from '../../Hooks/Features/HelpDesk/useProdServiceBuild';
import { MultiSelect } from 'primereact/multiselect';
import { calculateWordsFromString } from '../../utils/Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { useCommon } from '../../Hooks/Common/useCommon';
import { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';

const ProdServiceBuild = ({ dropdownOption, setShowRequestPopup, callApi, editData, setEditData }) => {

  const { projectOpts, getUserProjects } = useCommon();
  const { popupFields, setPopupFields, loader, handleSubmit, opts, disableStatus, handleBuildTypeChange, handleSearchChange, serviceView, setServiceView } = useProdServiceBuild({ projectOpts, dropdownOption, setShowRequestPopup, callApi, editData, setEditData });
  useEffect(() => {
    getUserProjects(true);
  }, [])


  return (
    <div>
      <div className='d-flex justify-content-between'>
        <div className="w45 mt-2">
          <div>Project Name</div>
          <Dropdown className="input-dd" options={projectOpts} optionLabel="project_name" value={popupFields?.project} onChange={(e) => setPopupFields((prev) => ({ ...prev, project: e.target.value }))} placeholder="Project" filter filterInputAutoFocus disabled={disableStatus?.project} />
        </div>
        <div className="w50 mt-2">
          <div>Project Module Name</div>
          <MultiSelect className="input-dd" options={opts?.project_module} optionLabel="option_value" value={popupFields?.project_module} onChange={(e) => setPopupFields((prev) => ({ ...prev, project_module: e.target.value }))} placeholder="Project Module" filter filterInputAutoFocus disabled={disableStatus?.project_module} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'project_module', popupFields?.project_module, () => setPopupFields((prev) => ({ ...prev, project_module: [] })))} />
        </div>
      </div>
      {opts?.build_type?.length > 0 && <div>
        <div className='w30 mt-2'>Build Type</div>
        <div className="d-flex gap-1" >
          {opts?.build_type?.map((build) => (
            <div key={build?.build_type_id} className={`border p-2 rounded help-desk-popup-roles ${popupFields?.build_type?.build_type_id === build?.build_type_id ? `helpdesk-popup-role-active${disableStatus?.build_type ? "-disable" : ""}` : ""} ${disableStatus?.build_type ? "prod-service-role-disable" : ""}`} onClick={() => { handleBuildTypeChange(build); }}>
              <span><FontAwesomeIcon icon="fa-solid fa-wrench" /> {build?.build_type_name}</span>
            </div>
          ))}
        </div>
      </div>}
      <div>
        <div className='w30 mt-2'>Jenkins Jobs</div>
        <div className='d-flex gap-2 align-items-center w100'>
          <div className={popupFields?.jenkins_job_type?.length > 5 ? "w95" : 'w100'}><MultiSelect className="input-dd" options={opts?.jenkins_job_type} optionLabel="jenkins_job_type_name" value={popupFields?.jenkins_job_type} onChange={(e) => setPopupFields((prev) => ({ ...prev, jenkins_job_type: e.target.value }))} placeholder="Jenkins Jobs" filter filterInputAutoFocus disabled={disableStatus?.jenkins_job_type} onInputCapture={handleSearchChange} />
          </div>
          {popupFields?.jenkins_job_type?.length > 5 && <FontAwesomeIcon icon="fa-solid fa-circle-info" className='p-1 c-pointer' style={{ fontSize: "16px" }} onClick={() => setServiceView({ show: true, data: popupFields?.jenkins_job_type })} />}
        </div>
      </div>
      {opts?.approver2?.length > 0 && <div className="mt-2">
        <div>Approver 2</div>
        <div className='d-flex flex-wrap gap-3 w100'>
          {opts?.approver2?.map((approver) => (
            <div key={approver?.client_id} className="d-flex align-items-center justify-content-center">
              <input type="radio" id={`approver2-${approver?.client_id}`} name="approver2" value={popupFields?.approver2} onChange={() => setPopupFields((prev) => ({ ...prev, approver2: approver }))} checked={(popupFields?.approver2?.client_id === approver?.client_id) && popupFields?.approver2?.client_id} style={{ marginLeft: 0 }} disabled={disableStatus?.approver2} />
              <label htmlFor={`approver2-${approver?.client_id}`}>{approver?.client_name}</label>
            </div>
          ))}
        </div>
      </div>}
      <div>
        <div className='mt-2'>Reason / Release Notes</div>
        <textarea rows={2} placeholder="Write reason for build" className="w100 form-control" value={popupFields?.reason} onChange={(e) => setPopupFields((prev) => ({ ...prev, reason: e.target.value }))} style={{ resize: "none" }} disabled={disableStatus?.reason} />
      </div>
      <div className="d-flex justify-content-between">
        {calculateWordsFromString(popupFields?.reason) > 5 ? <span></span> :
          <span>{calculateWordsFromString(popupFields?.reason)}/5 words</span>
        }
        <div className="d-flex justify-content-end align-items-center mt-3">
          <button className="button btn-default" onClick={() => { setShowRequestPopup(false); setEditData({}) }}>Cancel</button>
          {
            loader ? <button className="button btn-primary" style={{ width: "60px", height: "30px" }}>
              <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                <span className="sr-only"></span>
              </div>
            </button> :
              <button className="button btn-primary" onClick={handleSubmit}>Submit</button>
          }
        </div>
      </div>

      <Dialog visible={serviceView?.show} header="Services List" onHide={() => { setServiceView((prev) => ({ ...prev, show: false, data: [] })); }} className="modal-small" draggable={false}>
        {serviceView?.data?.map(item => (
          <div className='py-1 border-bottom'>{item?.jenkins_job_type_name}</div>
        ))}
      </Dialog>
    </div>
  )
}

export default ProdServiceBuild